// extracted by mini-css-extract-plugin
export default {"filter_mobile_hospital_content":"HospitalMobileScreen_filter_mobile_hospital_content__khF5z","checkboxList":"HospitalMobileScreen_checkboxList__j1f6-"};